<template>
  <div class="sub-page" :style="{paddingTop:showNum?'20px':'30px'}">
    <!-- 赛程 -->
    <div class="com-sch"  :class="showNum?'show-bg':''">
      <!-- 状态说明 -->
      <div class="status">
        <div class="sta-left"></div>
        <div class="sta-middle">
          <div >
            <a-month-picker @change="selectDate" style="width: 130px;margin-left: 35px;" :value="curDate?moment(curDate):null" placeholder="选择比赛月份"/>
          </div>
          <div class="statusinfo">
            <div class="sta-title" style="margin-left: 0;"><span class="dot  blue"></span> 比赛日</div>
            <div  class="sta-title"><span class="dot  yellow"></span>决赛日</div>
            <div  class="sta-title"><span class="dot  green"></span>开幕/闭幕式</div>
          </div>
          <!-- <div  class="sta-title"><span class="dot  dblue"></span>当日</div> -->
        </div>
        <div class="sta-right" v-if="!showNum"></div>
      </div>
      <!-- 赛程情况 -->
      <div class="sch-info">
        <div class="sch-left">
          <div class="title">项目</div>
            <div class="l-row" v-for="(item,index) in newProjectList" :key="index" :style="{'background-color':index%2==1?'#F7FBFD':''}" @click="goProject">
              <div class="l-col">
                <img :src="getIconUrl(item.programId)" alt="">
                <div>{{item.title}}</div>
              </div>
            </div>
        </div>
        <!-- :style="{overflowX:!showNum?'hidden':''}" -->
        <div class="sch-middle" ref="schMiddleTop">
          <div class="title">
            <div class="t-item" v-for="(item,index) in dataList" :key="index">
              <div class="m">{{item.m?Number(item.m)+"月":''}}</div>
              <div class="d">{{item.d}}</div>
              <div class="w">{{item.week}}</div>
            </div>
          </div>
          <div class="m-row"  v-for="(item,index) in newProjectList" :key="index" >
            <div class="m-col" v-for="(item,ind) in calculationTime.getStartEndAllDays(beginTime,endTime, item.dayList)" :key="ind" :style="{'background-color':index%2==1?'#F7FBFD':''}">
              <div class="m-item" ><span class="m-dot" :style="dotBg(item)" v-if="item.status !== 0" ></span></div>
            </div>
          </div>
          <template >
            <div class="arrow-left animate__animated animate__fadeOut" v-if="!showScheduleTop" @click.stop="changeScrollLeft">
              <a-icon type="left" />
            </div>
          </template>
          <template >
            <div class="arrow-right animate__animated animate__fadeOut" v-if="!showScheduleTop" @click.stop="changeScrollRitht" :style="{right:showNum?0:'240px'}" >
              <a-icon type="right" />
            </div>
        </template>
        </div>
        <div class="sch-right" v-if="!showNum">
          <div class="title">
            <div class="name">奖牌数量</div>
              <div class="num">
                <div class="num-left">
                  <div class="name">总数量</div>
                  <div class="nb">（{{calTotalPro.total}}）</div>
                </div>
                <div class="num-right">
                  <div class="name">已产生</div>
                  <div class="nb">（{{calTotalPro.total}}）</div>
                </div>
              </div>
          </div>
          <div class="r-col" v-for="(item,index) in newProjectList" :key="index" :style="{'background-color':index%2==1?'#F7FBFD':''}">
            <div style="border-left:1px solid #ACD0FD;border-right:1px solid #ACD0FD;">{{item.total}}</div>
            <div>{{item.pro}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import calculationTime from '@comm/utils/calculationTime.js'
import {getCurrenMothFisrtEndDay} from '@comm/utils/DateTime.js'
import { mapState } from 'vuex'
export default {
  name:'ScheduleCompetition',
  props:{
    showNum:{
      type:Boolean,
      default:false
    },
    scrollLeft:{
      type:Number,
      default:0
    },
    showScheduleTop:{
      type:Boolean,
      default:true
    }
  },
  data () {
    return {
      dataList:[],
      calculationTime,
      projectList1: [
        {
          id: 0,
          title: '仪式',
          icon: require('@daoba-match/assets/darkSportsLogo/1.png'),
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-04',
            status: 3
          },{
            day: '2023-02-15',
            status: 3
          }]
        },
        {
          id: 1,
          title: '跆拳道',
          icon: require('@daoba-match/assets/darkSportsLogo/1.png'),
          total:282,
          pro:123,
          dayList: [{
            day: '2023-02-06',
            status: 1
          },{
            day: '2023-02-07',
            status: 2
          },{
            day: '2023-02-08',
            status: 2
          }],

        }
      ],
      projectList:[],
      querySeriesMatchDetail:{},
      beginTime:'2023/02/03',
      endTime:'2023/10/10',
      // showLeft:false,
      // showRight:true,
    }
  },
  mounted () {
    this.getQuerySeriesMatchDetail()
    this.getScheduleList()
    this.$store.commit('match/MATCH_CHANGE_SCHEDULE_COMPETITION_DATE', null)
  },
  methods: {
    moment,
    //选择项目
    selectDate (e,dateStr){
      this.$store.commit('match/MATCH_CHANGE_SCHEDULE_COMPETITION_DATE', dateStr)
      this.$store.commit('match/MATCH_SCROLLTOLEFT', 0)
      // this.showLeft=false
      // this.showRight=true
    },
    //跳转项目
    goProject (){
      this.$router.push({
        name: 'Project',
      })
    },
    //点击左箭头
    changeScrollLeft (){
      let scrollLeft=this.$refs.schMiddleTop.scrollLeft
      if(scrollLeft!=0){
        this.$store.commit('match/MATCH_SCROLLTOLEFT', scrollLeft-960<0?0:scrollLeft-960)
      }
    },
    //点击右箭头
    changeScrollRitht (){
      let scrollLeft=this.$refs.schMiddleTop.scrollLeft
      let scrollWidth= this.$refs.schMiddleTop.scrollWidth
      if(scrollWidth>960){
        let left=scrollWidth-scrollLeft-960
        if(left>960){
          this.$store.commit('match/MATCH_SCROLLTOLEFT', left-960<0?scrollLeft + left-960: scrollLeft + 960)
          this.lastLeft=left-960<0?scrollLeft + left-960: scrollLeft + 960
        }else{
          this.lastLeft=scrollLeft + left
          this.$store.commit('match/MATCH_SCROLLTOLEFT', scrollLeft + left)
        }

      }
    },
    //日程状态色
    dotBg (item) {
      let colorObj={
        backgroundColor:''
      }

      switch(item.status){
      case 1:
        colorObj.backgroundColor='#009EDF'
        break
      case 2:
        colorObj.backgroundColor='#FFC907'
        break
      case 3:
        colorObj.backgroundColor='#007936'
        break
      default:
        colorObj.backgroundColor='#124584'
      }
      return colorObj
    },
    //项目logo
    getIconUrl (id){
      try {
        return require(`@daoba-match/assets/darkSportsLogo/${id}.png`)
      } catch (error) {
        return require('@daoba-match/assets/darkSportsLogo/999.png')
      }
    },
    //获取比赛项目
    async getScheduleList (){
      try {
        let res =await this.$api.district.scheduleList()
        if(res.status==0){
          this.projectList=res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log()
      }
    },
    //获取比赛日程
    async getQuerySeriesMatchDetail (){
      try {
        let res =await this.$api.district.querySeriesMatchDetail()
        if(res.status==0){
          this.querySeriesMatchDetail=res.data
          this.dataList=calculationTime.getStartEndAllDays(res.data.beginTime,res.data.endTime,this.projectList)
          this.beginTime=res.data.beginTime
          this.endTime=res.data.endTime
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },

  },
  computed: {
    ...mapState ({
      curDate: state => state.match.scheduleCompetitionDate,
      scrollToLeft:state => state.match.scrollToLeft
    }),
    newProjectList (){
      let arr=[]
      if(this.showNum){
        arr=this.projectList.slice(0,8)
      }else{
        arr = this.projectList
      }
      return arr
    },
    calTotalPro (){
      let obj={
        total:0,
        pro:0
      }
      obj.total = this.projectList.reduce((prev, cur)=>{
        return Number(cur.total)+Number(prev)

      },0)
      obj.pro = this.projectList.reduce((prev, cur)=>{
        return Number(cur.pro)+Number(prev)
      },0)
      return obj
    },

  },
  watch:{
    scrollLeft (newVal,oldVal){
      this.$refs.schMiddleTop.scrollLeft=newVal
    },
    curDate (newValue, oldValue) {
      const startEndDate=getCurrenMothFisrtEndDay(newValue)
      this.beginTime=startEndDate.firstDay
      this.endTime=startEndDate.lastDay
      this.dataList=calculationTime.getStartEndAllDays(this.beginTime,this.endTime,this.projectList)
    },
    scrollToLeft(newVal,oldVal){
      // console.log('ScheduleCompetition',newVal,oldVal);
      this.$refs.schMiddleTop.scrollLeft=this.scrollToLeft
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-page{
  border-top: 1px solid #E4E4E4;
  background-color: #FBFBFB;
  padding-top: 30px;
}
.com-sch{
  width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;
  margin-bottom: 40px;

  .blue{
    background-color: #009EDF;
  }
  .green{
    background-color: #007936;
  }
  .yellow{
    background-color: #FFC907;
  }
  // .dblue{
  //   background-color: #124584;
  // }
  //状态
  .status{
    width: 100%;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    .sta-left{
      width: 240px;
    }
    .sta-middle{
      width: 100%;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      .statusinfo{
        height: 100%;
        display: flex;
        justify-content: flex-end;
      }
      .sta-right{
        width: 240px;
        height: 100%;
      }
      .sta-title{
        margin-left: 20px;
        .dot{
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50px;
          margin:  0 5px;
        }
      }
    }
  }
  //赛程说明
  .sch-info{
    width: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    position: relative;

    //左边
    .sch-left{
      width: 240px;
      box-sizing: border-box;
      border-right: 1px solid #ACD0FD;
      .title{
        width: 100%;
        height: 80px;
        border-bottom: 4px solid #ACD0FD;
        line-height: 80px;
        font-weight: bold;
        font-size: 16px;

       }
       .l-col{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: bold;
        border-bottom: 1px solid #ACD0FD;
        box-sizing: border-box;
        height: 70px;
        font-size: 18px;
        img{
          width: 60px;
          height: 60px;
          margin-right: 10px;
        }
       }
    }
    //中间
    .sch-middle{
      max-width: 960px;
      min-height: 500px;
      box-sizing: border-box;
      overflow: scroll;
      overflow-y:hidden;
      overflow-X:hidden;
      .arrow-left{
        width: 60px;
        height: 60px;
        cursor: pointer;
        position: absolute;
        background-color: #ACD0FD;
        border-radius: 50%;
        line-height: 60px;
        color: #FFFFFF;
        text-align: center;
        font-size: 32px;
        z-index: 999;
        top: 250px;
        left: 240px;
      }
      .arrow-left:hover{
        opacity: 0.8;
      }
      .arrow-right{
        width: 60px;
        height: 60px;
        cursor: pointer;
        position: absolute;
        background-color: #ACD0FD;
        border-radius: 50%;
        line-height: 60px;
        color: #FFFFFF;
        text-align: center;
        font-size: 32px;
        z-index: 999;
        top: 250px;
        right: 240px;
      }
      .arrow-right:hover{
        opacity: 0.8;
      }
      .title{
        width: 100%;
        height: 80px;

        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        color: #282828;
        .t-item{
          width: 80px;
           border-bottom: 4px solid #ACD0FD;
          div{
            width: 80px;
            text-align: center;
          }
          .m{
            font-size: 14px;
            height: 25%;
            font-weight: 600;
          }
          .d{
            font-size: 20px;
            font-weight: bold;
          }
          .w{
            font-size: 14px;
             height: 25%;
             font-weight: bold;
          }
        }
      }
      .m-row{
        display: flex;
        width: 100%;
        height: 70px;
        justify-content: flex-start;
        align-items: center;
        line-height: 70px;
        font-weight: bold;
        .m-col{
          height: 100%;
          .m-item{
            width: 80px;
            height: 100%;
            border-bottom: 1px solid #ACD0FD;
            display: flex;
            justify-content: center;
            align-items: center;
            // border: 1px solid red;
            .m-dot{
              display: inline-block;
              width: 14px;
              height: 14px;
              border-radius: 50px;
              margin:  0 5px;
            }
          }
        }

      }
    }
    //右边
    .sch-right{
      width: 240px;
      box-sizing: border-box;
      .title{
        width: 240px;
        height: 80px;
        border-bottom: 4px solid #ACD0FD;
        border-left: 1px solid #ACD0FD;
        box-sizing: border-box;
        text-align: center;
        color: #282828;
        font-weight: bold;
        font-size: 16px;
        .name{
          width: 240px;
          font-size: 16px;
        }
        .num{
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          .name{
            width: 120px;
            box-sizing: border-box;
            font-size: 14px;
          }
           .num-left{
            width:120px;
            box-sizing: border-box;
            font-size: 14px;
          }
          .num-right{
            width:121px;
            box-sizing: border-box;
            font-size: 14px;
          }
        }
      }
      .r-col{
        width: 240px;
        height: 70px;
        border-bottom:1px solid #ACD0FD;
        display: flex;
        justify-content:justify-content;
        align-items: center;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        line-height: 70px;
        box-sizing: border-box;
        div{
          width: 50%;
          height: 100%;
        }

      }
    }
  }
}
.show-bg{
  width: 1200px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/district/components/common/ScheduleCompetition.vue